import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { indexedDB } from '../../indexedDB'
import { PendingBulkRequest } from './schema'

type DeleteMutationOptions = UseMutationOptions<
  number,
  unknown,
  Pick<PendingBulkRequest, 'id'>
>

export const useDeletePendingBulkRequest = (
  options?: DeleteMutationOptions
) => {
  return useMutation({
    ...options,
    mutationFn: async ({ id }) => {
      await indexedDB.pendingBulkRequests.delete(id)
      return id
    },
  })
}
